import { useNavigate } from "react-router-dom";





function ListaReservas({ reservas = [], servicios, usuario, quienEs }) {
    const navigate = useNavigate();


    function enviarAreserva(idReserva) {

        const urlAusar =  quienEs === "Vendedor" ? "/vendedor/reserva" : "/usuario/ver-reserva";
 
        navigate( urlAusar, {
            state: {
                idReserva,
                idUsuario: usuario?.idUsuario,
                quienEs: usuario?.modo
            }
        });
    }


 
    return (
         <div className="container">
                {reservas.length === 0 ? (
                    <div className="alert alert-light border">No tienes reservas todavía.</div>
                ) : (
                    <div className="d-flex flex-column gap-4">
                        {reservas.map((reserva) => {
                            const servicioEncontrado = servicios.find(
                                (servicio) => servicio?.idServicio === reserva?.idServicio
                            );

                            const primeraImagen = servicioEncontrado?.imagenes?.[0] || "";

                            const descripcionServicio = (servicioEncontrado?.descripcion || "").trim();
                            const extractoDescripcion = descripcionServicio.length > 30
                                ? `${descripcionServicio.slice(0, 30)}...`
                                : descripcionServicio;
                            const textoEstado =
                                reserva?.reclamo?.abierto === true
                                    ? "En disputa"
                                    : reserva?.estado === "hold"
                                        ? "Pendiente hora"
                                        : (reserva?.estado || "NA");

                            return (
                                <div
                                    key={reserva._id}
                                    className="card shadow-sm border-0 rounded-4"
                                    style={{ background: "var(--color-bg-surface)" }}
                                >
                                    <div className="card-body px-4 py-4">
                                        <div className="row align-items-center g-3 g-xl-4">
                                            <div className="col-12 col-md-2 col-xl-1">
                                                {primeraImagen ? (
                                                    <img src={primeraImagen} alt={servicioEncontrado?.nombre || "Servicio"} style={{ width: "96px", height: "96px", objectFit: "cover", borderRadius: "18px", border: "1px solid var(--color-border)", display: "block", }} />
                                                ) : (
                                                    <div className="d-flex align-items-center justify-content-center border rounded-4 text-secondary" style={{ width: "96px", height: "96px" }} > Sin imagen </div>
                                                )}
                                            </div>

                                            <div className="col-12 col-md-3 col-xl-3">
                                                <div className="d-flex flex-column pe-xl-2">
                                                    <span className="fw-bold text-dark" style={{ fontSize: "0.95rem", lineHeight: 1.35, display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden", }} >
                                                        {servicioEncontrado?.nombre || "Servicio sin nombre"}
                                                    </span>
                                                    <span className="text-secondary mt-2" style={{ fontSize: "0.95rem", lineHeight: 1.45, display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", }} >
                                                        {extractoDescripcion || "Sin descripción"}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-2 col-xl-2">
                                                <div className="d-flex flex-column">
                                                    <span className="text-secondary fw-semibold mb-1" style={{ fontSize: "0.95rem" }}>Total de la compra</span>
                                                    <span className="fw-bold text-dark" style={{ fontSize: "1.65rem", lineHeight: 1.05 }}>
                                                        $ {Number(reserva?.cobro?.montoTotal || 0).toLocaleString("es-CO")}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-2 col-xl-2">
                                                <div className="d-flex flex-column">
                                                    <span className="text-secondary fw-semibold mb-1" style={{ fontSize: "0.95rem" }}>Fecha de la compra</span>
                                                    <span className="fw-bold text-dark" style={{ fontSize: "1.05rem", lineHeight: 1.35 }}>
                                                        {reserva?.createdAt ? new Date(reserva.createdAt).toLocaleDateString("es-CO", {
                                                            day: "numeric",
                                                            month: "long",
                                                            year: "numeric",
                                                        }) : "NA"}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-1 col-xl-2">
                                                <div className="d-flex flex-column">
                                                    <span className="text-secondary fw-semibold mb-1" style={{ fontSize: "0.95rem" }}>Estado</span>
                                                    <span
                                                        className="fw-semibold text-capitalize rounded-pill px-3 py-2 text-center"
                                                        style={{
                                                            fontSize: "0.95rem",
                                                            width: "fit-content",
                                                            background:
                                                                reserva?.reclamo?.abierto === true ? "rgba(var(--naranja-cta-rgb), 0.14)" :
                                                                reserva?.estado === "confirmado" ? "rgba(var(--verde-bootstrap-rgb), 0.12)" :
                                                                reserva?.estado === "cancelado" ? "rgba(var(--rojo-error-rgb), 0.12)" :
                                                                reserva?.estado === "completado" ? "rgba(var(--azul-medio-rgb), 0.10)" :
                                                                "rgba(var(--texto-gris-oscuro-rgb), 0.12)",
                                                            color:
                                                                reserva?.reclamo?.abierto === true ? "var(--naranja-cta)" :
                                                                reserva?.estado === "confirmado" ? "var(--verde-bootstrap)" :
                                                                reserva?.estado === "cancelado" ? "var(--rojo-error)" :
                                                                reserva?.estado === "completado" ? "var(--azul-medio)" :
                                                                "var(--texto-gris-oscuro)"
                                                        }}
                                                    >
                                                        {textoEstado}
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="col-12 col-md-2 col-xl-2">
                                                <div className="d-flex flex-column justify-content-center align-items-md-start h-100">
                                                    <button
                                                        type="button"
                                                        className="btn btn-outline-primary rounded-pill px-3 py-2 fw-semibold"
                                                        style={{ width: "100%", maxWidth: "180px" }}
                                                        onClick={() => enviarAreserva(reserva._id) }
                                                    >
                                                        Ver reserva
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
    );
}


export default ListaReservas;